import Model, { attr, belongsTo } from '@ember-data/model';

export default class ClinicianDocumentReviewModel extends Model {
  @belongsTo('team-member', { async: false, inverse: null }) reviewedByUser;
  @belongsTo('treatable-client', { polymorphic: true, async: false, inverse: null }) client;
  @belongsTo('practice', { async: false, inverse: null }) practice;

  @attr('string') status;
  @attr('moment') createdAt;
  @attr('moment') updatedAt;
  @attr('moment') reviewedAt;
}
